import * as angular from "angular";
import {IController} from "angular";

export class selfPickupsViewNoDepotsCtrl implements IController {

  /* @ngInject */
  constructor(private $state) {
  }

  onAction() {
    this.$state.go('depots');
  }

}

angular
  .module('bringoz.admin.self-pickups')
  .component('selfPickupsViewNoDepots', {
    bindings: {},
    template: require('./self-pickups-view-no-depots.html').default,
    controller: selfPickupsViewNoDepotsCtrl
  });
